import Vue from 'vue';
import {
    Avatar,
    Carousel,
    message,
    List,
    notification,
    Spin,
    Table,
    Button,
    Modal,
    Popover,
    tooltip,
    icon,
    row,
    col,
    Tabs,
    Input,
    Checkbox,
    Radio,
    Dropdown,
    Menu,
    Select,
    DatePicker,
    Form,
    Pagination,
    Empty,
    ConfigProvider,
    LocaleProvider
} from 'ant-design-vue';

Vue.use(col);
Vue.use(row);
Vue.use(tooltip);
Vue.use(icon);
Vue.use(Popover);
Vue.use(Avatar);
Vue.use(Button);
Vue.use(Modal);
Vue.use(Carousel);
Vue.use(List);
Vue.use(message);
Vue.use(notification);
Vue.use(Spin);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Radio);
Vue.use(Dropdown);
Vue.use(Menu);
Vue.use(Select);
Vue.use(DatePicker);
Vue.use(Form);
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(ConfigProvider);
Vue.use(LocaleProvider);

Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$spin = Spin;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$form = Form;
